import cmd, { BaseResponse } from '../../cmd';

type VerifyTokenData = [] | string;

export const verifyToken = (): Promise<BaseResponse<VerifyTokenData>> => {
  return cmd<VerifyTokenData>({ cmd: 'login', method: 'post' });
};

export default verifyToken;
